import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Space, Tag, Tooltip } from 'tdesign-react';
import { LogoCodesandboxIcon } from 'tdesign-icons-react';
import { sleep } from '@/utils/common';
import { generateHosts, removeGroupHost } from '@/slices/execFlowSlice';

function GroupItem({
  currentGroup,
  openHostSelect,
  groupHostsList,
  removeGroupHost,
  generateHosts,
}) {
  const hosts = groupHostsList.find((item) => item.groupId === currentGroup.id)?.hosts || [];
  return (
    <Root>
      <Space breakLine align='center'>
        <Title>
          <Tooltip content='主机组'>
            <LogoCodesandboxIcon color='var(--td-text-color-secondary)' />
          </Tooltip>
          &nbsp;
          {currentGroup.name}：{currentGroup.explains}
        </Title>
        <Button theme='primary' variant='outline' size='small' onClick={() => openHostSelect()}>
          选择机器
        </Button>
      </Space>

      {!isEmpty(hosts) && (
        <HostContainer>
          <Space breakLine size={[8, 10]}>
            {hosts.map((host) => (
              <Tag
                theme='success'
                key={`${currentGroup.id}$${host.id}`}
                onClose={async () => {
                  removeGroupHost({
                    currentGroup,
                    hostId: host.id,
                  });
                  await sleep(10);
                  generateHosts();
                }}
                variant='light-outline'
                closable
              >
                {host.serviceIp || host.hostIp}
              </Tag>
            ))}
          </Space>
        </HostContainer>
      )}
    </Root>
  );
}

export default connect(
  (state) => ({
    groupHostsList: state.execFlow.groupHostsList,
  }),
  {
    removeGroupHost,
    generateHosts,
  },
)(GroupItem);

const Root = styled.div`
  margin-bottom: 10px;
`;

const Title = styled.div`
  font-size: 13px;
  color: var(--td-text-color-primary);
  display: flex;
  align-items: center;
`;

const HostContainer = styled.div`
  padding-top: 10px;
  box-sizing: border-box;
`;
